interface ProgressBarProps {
    title?: string;
    percentage: number;
    onlyProgressBar?: boolean;
    color?: "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark" | "primary-light";
    bgColor?: "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark" | "primary-light";
    size?: "sm" | "md" | "lg";
}
const ProgressBar:React.FC<ProgressBarProps> = ({title, percentage, onlyProgressBar=false, size="sm", color="primary", bgColor="secondary"}) => {
    const normalizedPercentage =
        Number.isFinite(percentage)
            ? Math.min(100, Math.max(0, percentage))
            : 0;
    return (
        <div className="d-flex align-items-center w-100 flex-column mt-3">
            {!onlyProgressBar && (
                <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                    <span className="fw-bold fs-6 text-gray-500">{title}</span>
                    <span className="fw-bolder fs-6">{normalizedPercentage}%</span>
                </div>
            )}
            <div className={`mx-3 w-100 bg-${bgColor} rounded mb-3 ${size === "sm" ? "h-5px" : size === "md" ? "h-10px" : "h-15px"}`}>
                <div className={`bg-${color} rounded h-100`} role="progressbar" style={{width:`${normalizedPercentage}%`}}></div>
            </div>
        </div>
    )
}

export default ProgressBar;